// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warpper[data-v-e25cbe24]{display:inline-block;font-size:.875rem;line-height:1.25rem;margin-top:2rem;margin-bottom:2rem;margin-right:2.75rem;margin-left:3rem;max-width:100%}@media (min-width:768px){.warpper[data-v-e25cbe24]{margin-right:3rem;max-width:50%!important}}.text[data-v-e25cbe24]{border-radius:var(--motif-radius);display:inline-block;padding:14px 18px;color:#666;font-size:15px;line-height:24px;background:#f8f8fa}", ""]);
// Exports
module.exports = exports;
